import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useMembership } from '../../hooks/users';

const Styles = styled.div`
  img {
    width: 100%;
    filter: blur(1.5px);
  }
  div {
    position: relative;
  }
  span {
    display: inline-block;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: red;
    padding: 1rem;
    font-size: 1.5rem;
    color: white;
    border-radius: 0.5rem;
    opacity: 0.7;
    font-weight: bold;
  }
`;

interface Props {
  showContent?: boolean;
  featureKey: string;
}

const BlurPlaceholder: React.FC<React.PropsWithChildren<Props>> = props => {
  const hasMembership = useMembership();
  const { t, i18n } = useTranslation();

  return !hasMembership && !props.showContent ? (
    <>
      <Styles>
        <div>
          <img
            style={{ width: '100%' }}
            alt={props.featureKey}
            src={`${process.env.PUBLIC_URL}/images/blur-placeholders/${props.featureKey}-${i18n.language}.png`}
          />
          <span>{t('DEMO')}</span>
        </div>
      </Styles>
    </>
  ) : (
    <>{props.children}</>
  );
};

export default BlurPlaceholder;
